export default "__VITE_ASSET__BUIa_jJL__"